module.exports = __webpack_public_path__ + "static/media/CTLI_2-315w.34a39bd0.webp";